export interface IChubbBillInsurancesResponse {
  jointBillService: IChubbBillInsuranceJointBillService[];
}

export interface IChubbBillInsuranceJointBillService {
  jointBillServiceId: number;
  insuranceStatus: TChubbBillInsuranceStatus;
  isFakeAddress: boolean;
  displayName: string;
  address: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email: string;
  phoneNumber: string;
  validTo: Date;
}

export interface IChubbBillInsuranceOrdersResponse {
  customer: IChubbBillInsuranceOrdersCustomer;
  jointBillServices: IChubbBillInsuranceOrdersJointBillService[];
}

export interface IChubbBillInsuranceOrdersCustomer {
  customerId: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface IChubbBillInsuranceOrdersJointBillService {
  jointBillServiceId: number;
  isFakeAddress: boolean;
  displayName: string;
  address: string;
}

export interface IChubbBillInsuranceOrdersRequest {
  jointBillServiceId: number;
  dateOfBirth: Date;
  acceptedBillInsuranceTerms: boolean;
  acceptedDataTransferToBillInsurer: boolean;
}

export type TChubbBillInsuranceStatus =
  | null
  | "default"
  | "inactive"
  | "active";

export const DEFAULT_CHUBB_BILL_INSURANCE_SERVICE_PROVIDER_ID = 2842;
